function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { Checkbox } from 'mkui-fd';
import classNames from 'classnames';
import Animate from 'rc-animate';
import PropTypes from 'prop-types';
import _ from 'lodash';

var SourceList = /*#__PURE__*/function (_Component) {
  _inherits(SourceList, _Component);

  function SourceList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SourceList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SourceList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      checkedList: _this.props.checkedList || []
    });

    _defineProperty(_assertThisInitialized(_this), "checkAllHandle", function (e) {
      var data = _this.props.data;
      var checkAll = e.target.checked;

      var checkedList = _.cloneDeep(_this.state.checkedList);

      if (checkAll) {
        var list = [];
        data.forEach(function (o) {
          if (o.disabled) return;

          if (!~checkedList.findIndex(function (p) {
            return p.key === o.key;
          })) {
            list.push(o);
          }
        });
        checkedList = checkedList.concat(list);
      } else {
        checkedList = checkedList.filter(function (o) {
          if (o.disabled) return true;
          return !~data.findIndex(function (p) {
            return o.key === p.key;
          });
        });
      }

      _this.onChangeHandle(checkedList);
    });

    _defineProperty(_assertThisInitialized(_this), "selectItemHandle", function (e, item) {
      var selectType = _this.props.selectType;
      var checkState = e.target.checked;

      if (selectType === 'radio') {
        return _this.onChangeHandle(checkState ? [item] : []);
      }

      var checkedList = _.cloneDeep(_this.state.checkedList);

      if (checkState) {
        checkedList.push(item);
      } else {
        var index = checkedList.findIndex(function (o) {
          return o.key === item.key;
        });

        if (index !== -1) {
          checkedList.splice(index, 1);
        }
      }

      _this.onChangeHandle(checkedList);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeHandle", function (checkedList) {
      var onChange = _this.props.onChange;

      if (!('checkedList' in _this.props)) {
        _this.setState({
          checkedList: checkedList
        });
      }

      onChange(checkedList);
    });

    _defineProperty(_assertThisInitialized(_this), "getCheckStateFromData", function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (data.length <= 0) {
        return {
          checkAll: false,
          indeterminate: false
        };
      }

      var checkedList = _this.state.checkedList;
      var indeterminate = false;
      var num = 0;
      var disNum = 0;
      data.forEach(function (o) {
        var state = ~checkedList.findIndex(function (p) {
          return p.key === o.key && !o.disabled;
        });

        if (state) {
          num++;
          indeterminate = true;
        }

        if (o.disabled) {
          disNum++;
        }
      });
      var checkAll = num === data.length - disNum;
      return {
        checkAll: checkAll,
        indeterminate: checkAll ? false : indeterminate
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderNode", function (type, item, _class) {
      var prefixCls = _this.props.prefixCls;
      if (type === false || type === null) return null;

      var _className = classNames("".concat(prefixCls, "-item-render"), _defineProperty({}, _class, _class));

      if (typeof type === 'function') {
        return React.createElement("div", {
          className: _className
        }, type(item));
      }

      return React.createElement("div", {
        className: _className
      }, item.title);
    });

    return _this;
  }

  _createClass(SourceList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          selectType = _this$props.selectType,
          data = _this$props.data,
          renderProps = _this$props.renderProps,
          prefixCls = _this$props.prefixCls;
      var checkedList = this.state.checkedList;
      var _renderProps$icon = renderProps.icon,
          icon = _renderProps$icon === void 0 ? false : _renderProps$icon,
          _renderProps$content = renderProps.content,
          content = _renderProps$content === void 0 ? '' : _renderProps$content,
          _renderProps$option = renderProps.option,
          option = _renderProps$option === void 0 ? false : _renderProps$option;

      var _this$getCheckStateFr = this.getCheckStateFromData(data),
          checkAll = _this$getCheckStateFr.checkAll,
          indeterminate = _this$getCheckStateFr.indeterminate;

      return React.createElement("div", {
        className: prefixCls
      }, selectType === 'multiple' && React.createElement("div", {
        className: "".concat(prefixCls, "-item check-all")
      }, React.createElement(Checkbox, {
        indeterminate: indeterminate,
        onChange: this.checkAllHandle,
        checked: checkAll,
        disabled: data.length <= 0
      }, "\u5168\u9009")), React.createElement(Animate, {
        transitionName: "fade",
        component: "div",
        className: "".concat(prefixCls, "-ul")
      }, data.length > 0 ? data.map(function (item) {
        return React.createElement("div", {
          className: "".concat(prefixCls, "-item"),
          key: item.key
        }, React.createElement(Checkbox, {
          disabled: item.disabled,
          onChange: function onChange(e) {
            return _this2.selectItemHandle(e, item);
          },
          checked: ~checkedList.findIndex(function (o) {
            return o.key === item.key;
          })
        }), _this2.renderNode(icon, item, 'icon'), _this2.renderNode(content, item), _this2.renderNode(option, item, 'right'));
      }) : React.createElement("div", {
        className: "".concat(prefixCls, "-nodata")
      }, "\u6682\u65E0\u76F8\u5173\u6570\u636E")));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('checkedList' in nextProps) {
        return {
          checkedList: nextProps.checkedList || []
        };
      }

      return null;
    }
  }]);

  return SourceList;
}(Component);

_defineProperty(SourceList, "propTypes", {
  prefixCls: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    title: PropTypes.string
  })),
  renderProps: PropTypes.shape({
    icon: PropTypes.renderNode,
    content: PropTypes.renderNode,
    option: PropTypes.renderNode
  }),
  onChange: PropTypes.func
});

_defineProperty(SourceList, "defaultProps", {
  prefixCls: 'mkui-abstract-transfer-source-list',
  renderProps: {},
  onChange: function onChange() {}
});

export { SourceList as default };
//# sourceMappingURL=SourceList.js.map
